import React, { useRef, useState } from "react";
import {
    Modal, Input, message, Tooltip, Button, Progress
} from "antd";
import { CopyOutlined } from "@ant-design/icons";
import ReportsServices from "../../services/Reports.services";
import OneIntelligenceServices from "../../services/OneIntelligence.services";

function PublishDashboardModal({
    visible,
    onClose = () => { }
}) {
    const copyPreviewUrl = useRef();
    const copyPassword = useRef();
    const [filename, setfilename] = useState(ReportsServices.getMastersTargetAudience());
    const [previewPath, setPreviewPath] = useState("");
    const [publishPassword, setPublishPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [percentage, setPercentage] = useState(0);

    const copyFunction = (value) => {
        navigator.clipboard.writeText(value.trim());
        message.info("Copied to clipboard.");
    };
    return (
        <Modal
            className="report--freeformmodal"
            open={visible}
            closable={false}
            maskClosable={false}
            title="Publish Dashboard"
            okText={isLoading ? "Publishing..." : "Publish"}
            cancelText={previewPath && publishPassword ? "Done" : "Cancel"}
            cancelButtonProps={{
                disabled: isLoading
            }}
            okButtonProps={{
                loading: isLoading
            }}
            onCancel={() => {
                onClose(false);
            }}
            onOk={async () => {
                if (!filename) {
                    message.warning("Please input filename.");
                    return;
                }
                setIsLoading(true);
                const fProgress = ({ loaded, total }) => {
                    setPercentage(((loaded / total) * 100) - 5);
                };
                const { password, path, error } = await OneIntelligenceServices.publishDashboard(filename, fProgress);
                setIsLoading(false);
                if (error) {
                    message.warning("Filename already exist.");
                    return;
                }
                setPercentage(100);
                message.success("Successfully published dashboard.");
                setPreviewPath(path);
                setPublishPassword(password);
                setTimeout(() => {
                    setPercentage(0);
                }, 500);
            }}
        >
            <div className="d-flex-col gap-1">
                <div className="d-flex-col justify-content-center">
                    <span>Filename: </span>
                    <Input
                        value={filename}
                        onChange={(e) => setfilename(e.target.value)}
                    />
                </div>
                {percentage > 0 ? <Progress percent={parseInt(percentage, 10)} status="active" /> : null}
                {previewPath && (
                    <div className="d-flex-col justify-content-center">
                        <span>Preview Path: </span>
                        <Input.Group compact>
                            <Input
                                style={{ width: "calc(100% - 28.5mm)" }}
                                value={previewPath}
                                readOnly
                                ref={copyPreviewUrl}
                            />
                            <Button
                                style={{
                                    padding: "1mm"
                                }}
                                onClick={() => {
                                    window.open(previewPath, "_target");
                                }}
                            >
                                Open Link
                            </Button>
                            <Tooltip title="Copy preview URL.">
                                <Button
                                    icon={<CopyOutlined />}
                                    onClick={() => {
                                        copyFunction(copyPreviewUrl.current.input.value);
                                    }}
                                />
                            </Tooltip>
                        </Input.Group>
                    </div>
                )}

                {publishPassword && (
                    <div className="d-flex-col justify-content-center">
                        <span>Password: </span>
                        <Input.Group compact>
                            <Input
                                style={{ width: "calc(100% - 9mm)" }}
                                value={publishPassword}
                                readOnly
                                ref={copyPassword}
                            />
                            <Tooltip title="Copy password.">
                                <Button
                                    icon={<CopyOutlined />}
                                    onClick={() => {
                                        copyFunction(copyPassword.current.input.value);
                                    }}
                                />
                            </Tooltip>
                        </Input.Group>
                    </div>
                )}
            </div>
        </Modal>
    );
}

export default PublishDashboardModal;
